import { MutationTree } from 'vuex';
import { SessionState } from '../stores/session.store';
import { ISession } from '@/types/Session';
import { IUser } from '@/types/User';

export const mutationSetSession = 'setSession';
export const mutationSetSessionIsLoading = 'setSessionIsLoading';
export const mutationSetSessionIsLoaded = 'setSessionIsLoaded';
export const mutationSetToken = 'setToken';
export const mutationSetUser = 'setUser';

export const mutations: MutationTree<SessionState> = {
  [mutationSetSession](state: SessionState, session: ISession) {
    state.session = session;
  },
  [mutationSetSessionIsLoading](state: SessionState, loading: boolean) {
    state.sessionIsLoading = loading;
  },
  [mutationSetSessionIsLoaded](state: SessionState, loaded: boolean) {
    state.sessionIsLoaded = loaded;
  },
  [mutationSetToken](state: SessionState, token: string) {
    state.token = token;
  },
  [mutationSetUser](state: SessionState, user: IUser) {
    state.user = user;
  },
};
